//action,mutations
export const FETCH_CLIENT_INFORMATION = "fetchClientInformation";
export const FETCH_AUTH_INFORMATION = "fetchAuthInformation";

export const SET_Footer_SAVE_BUTTON_STATUS = "setFooterSaveButtonStatus";
export const SET_Footer_CANCEL_BUTTON_STATUS = "setFooterCancelButtonStatus";
export const SET_Footer_BACK_BUTTON_STATUS = "setFooterBackButtonStatus";
export const SET_Footer_STATUS = "setFooterStatus";

export const SET_AUTH_INFORMATION = "setAuthInformation";
export const SET_JWT_AUTH_INFORMATION = "setJWTAuthInformation";

export const SET_JWT_AUTH_TOKEN = "setJWTAuthToken";

export const SET_CLIENT_INFORMATION = "setClientInformation";
export const SET_CLIENT_Session = "setClientSession";
export const SET_LOADER_VISIBILITY = "setLoaderVisibility";
export const SET_Liablity_INFORMATION = "setLiablityInformation";

export const SET_Liablity_DEFAULT_MODEL = "setLiablityDefaultModel";
export const SET_Liablity_ENTITY_INFORMATION = "setLiablityEntityInformation";
export const SET_Liablity_TYPE_INFORMATION = "setLiablityTypeInformation";

export const SET_SELECTED_Liablity_INFORMATION =
  "setSelectedLiablityInformation";

export const SET_ICE_API_RESPONSE = "setIceApiResponse";
export const SET_LOAN_CHART_MODEL = "setloanChartModel";
export const SET_NOTIFICATION_SUMMARY = "setNotificationSummary";
export const SET_ENGAGEMENT_COUNT = "setEngagementCount";
export const SET_RISK_PROFILE_DATA = "setRiskProfileData";
export const SET_COMPARE_LOAN_INFO = "setCompareLoanInfo";
export const SET_COMPARE_INVESTMENTS_INFO = "setCompareInvestmentsInfo";
export const SET_ICE_PROJECTION_MODEL = "setIceProjectionModel";
export const GET_ICE_PROJECTION_MODEL = "getIceProjectionModel";
export const GET_PROJECTION_MODEL = "getProjectionModel";

export const SET_PROJECTION_API_RESPONSE = "setProjectionApiResponse";
export const SET_PROJECTION_MODEL = "setProjectionModel";

export const SET_ALL_LIABILITY_INFORMATION = "setAllLiablityInformation";

//getters

export const GET_AUTH_INFORMATION = "getAuthInformation";
export const GET_ICE_API_RESPONSE = "getIceApiResponse";
export const GET_PROJECTION_API_RESPONSE = "getProjectionApiResponse";
export const GET_NOTIFICATION_SUMMARY = "getNotificationSummary";
export const GET_LOAN_CHART_MODEL = "getLoanChartModel";

export const GET_COMPARE_LOAN_INFO = "getCompareLoanInfo";
export const GET_COMPARE_INVESTMENTS_INFO = "getCompareInvestmentsInfo";
export const GET_LOADER_VISIBILITY = "getLoaderVisibility";
export const GET_CLIENT_INFORMATION = "getClientInformation";
export const GET_CLIENT_Session = "getClientSession";
export const GET_LIABLITY_INFORMATION = "getLiablityInformation";

export const GET_Liablity_ENTITY_INFORMATION = "getLiablityEntityInformation";
export const GET_Liablity_TYPE_INFORMATION = "getLiablityTypeInformation";

export const GET_SELECTED_LIABLITY_INFORMATION =
  "getSelectedLiablityInformation";
export const GET_ENGAGEMENT_COUNT = "getEngagementCount";
/////////////////////////////////////////////Invetsment///////////////////////////////////////////////////////////////

export const SET_INVESTMENT_DEFAULT_MODEL = "setInvestmentDefaultModel";
export const SET_INVESTMENT_CHART_MODEL = "setInvestmentChartModel";
export const SET_INVESTMENT_INFORMATION = "setInvestmentInformation";
export const SET_INVESTMENT_ENTITY_INFORMATION =
  "setInvestmentEntityInformation";
export const SET_SELECTED_INVESTMENT_INFORMATION =
  "setSelectedInvetsmentInformation";
export const SET_ALL_INVESTMENT_INFORMATION = "setAllInvestmentInformation";

export const SET_ALL_SUPER_INFORMATION = "setAllSuperInformation";
export const SET_SELECTED_SUPER_INFORMATION = "setSelectedSuperInformation";

export const SET_INVESTMENT_TYPE_INFORMATION = "setInvestmentTypeInformation";
export const GET_INVESTMENT_CHART_MODEL = "getInvestmentChartModel";
export const GET_INVESTMENT_ENTITY_INFORMATION =
  "getInvestmentEntityInformation";
export const GET_INVESTMENT_TYPE_INFORMATION = "getInvestmentTypeInformation";
export const GET_INVESTMENT_INFORMATION = "getInvestmentInformation";
export const GET_SELECTED_INVESTMENT_INFORMATION =
  "getSelectedInvestmentInformation";
export const GET_SELECTED_SUPER_INFORMATION = "getSelectedSuperInformation";
export const GET_ALL_SUPER_INFORMATION = "getAllSuperInformation";
export const GET_RISK_PROFILE_DATA = "getRiskProfileData";

////////////////////////////////SuperAnnuation/////////////////////////////////
export const SET_SUPERANNUATION_DEFAULT_MODEL = "setSuperannuationDefaultModel";
export const SET_SELECTED_SUPERANNUATION_INFORMATION =
  "setSelectedSuperannuationInformation";
export const SET_SUPERANNUATION_INFORMATION = "setSuperannuationInformation";
export const SET_SUPERANNUATION_ENTITY_INFORMATION =
  "setSuperannuationEntityInformation";
export const SET_ALL_SUPERANNUATION_INFORMATION =
  "setAllSuperannuationInformation";
export const SET_SUPERANNUATION_CHART_MODEL = "setSuperannuationChartModel";
export const SET_COMPARE_SUPERANNUATIONS_INFO = "SetCompareSuperannuationsInfo";
export const GET_SUPERANNUATION_ENTITY_INFORMATION =
  "getSuperannuationEntityInformation";
export const GET_SUPERANNUATION_INFORMATION = "getSuperannuationInformation";
export const GET_SELECTED_SUPERANNUATION_INFORMATION =
  "getSelectedSuperannuationInformation";
export const GET_COMPARE_SUPERANNUATIONS_INFO = "getCompareSuperannuationsInfo";
export const GET_SUPERANNUATION_CHART_MODEL = "getSuperannuationChartModel";
